const trackMyOrderProcessNodeComponentDefinition = {
    template: require('./track-my-order-process-node.component.html').trim(),
    bindings: {
        label: '@',
        isStepCompleted: '<',
    },
};

module.exports = {
    trackMyOrderProcessNodeComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/trackmyorder/track-my-order-process-node.component.js